

































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import InputImageTextBox from "./AnswerOptions/InputImageTextBox.vue";
import ButtonProfi from "../ButtonProfi.vue";
import Description from "../Description.vue";
import Headline from "../Headline.vue";
import { Question } from "../../types/DataSource";

@Component({
  components: {
    "input-image-text-box": InputImageTextBox,
    "button-profi": ButtonProfi,
    "description-profi": Description,
    "headline-profi": Headline
  }
})
export default class ImageTextBoxQuestion extends Vue {
  @Prop({ default: () => [] }) private selected!: [string];
  @Prop({ required: true }) private question!: Question;

  private selectedId = this.selected[0];

  get buttonDisabled() {
    return this.selectedId == null;
  }

  get descriptionVisible() {
    return this.selectedId != null;
  }

  get descriptionText() {
    const selectedAnswer = this.question.answers.find(answer => {
      return answer.id == this.selectedId;
    });

    if (selectedAnswer != undefined) {
      return selectedAnswer.description;
    }

    return "";
  }

  get isEmitOnClickActivated() {
    return this.$store.state.globalConfig.onClickQuestions;
  }

  @Emit("next")
  private confirmAnswer(): [string] {
    return [this.selectedId];
  }
}
